<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="门店管理">
      <!-- 超管、开发者才可以新增 -->
      <template v-if="roleId == 1 || roleId == 9">
        <el-button size="small" type="primary" @click="newlyAdded"
          >新增</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 0
                  ? 'iconfont icon-lock'
                  : 'iconfont icon-jihuo'
              "
            ></i
            >{{ row.row.status == 0 ? "锁定" : "激活" }}
          </div>

          <!-- 超管、开发者才可以增、减 -->
          <template v-if="roleId == 1 || roleId == 9">
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 激活
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  getshoplist,
  shopdel,
  shopactive,
  shopLock,
  companyGetlist,
  areaGetlist,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
  is_showAll: 1,
};
export default {
  name: "storeManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "商户",
            type: "select",
            options: [],
            key: "comp_id",
          },
          {
            label: "区域",
            type: "treeselect",
            options: [],
            key: "area_number",
          },
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "名称/店长/电话/地址",
            type: "input",
            key: "keywords",
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "启用",
                value: 0,
              },
              {
                label: "禁用",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "排序",
            prop: "sort_order",
            sortable: true,
            width: 60,
          },
          {
            label: "商户",
            prop: "comp_name",
            width: 150,
          },
          {
            label: "门店名称",
            prop: "name",
            width: 100,
          },
          {
            label: "店长",
            prop: "user_name",
            width: 100,
          },
          {
            label: "电话",
            prop: "tel",
            width: 100,
          },
          {
            label: "类型",
            prop: "type",
            filter: "storeType",
          },
          {
            label: "地址",
            prop: "address",
          },
          {
            label: "烟",
            prop: "is_smork",
            filter: "isYes",
          },
          {
            label: "回收",
            prop: "is_old",
            filter: "isYes",
          },
          {
            label: "人员数",
            prop: "user_qty",
            sortable: true,
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 门店管理中：商户只能编辑基础信息
    this.roleId = this.$store.getters.userRole;
    if (this.roleId != 1) {
      this.basicListconfig.search.shift();
    }
    this.compId = this.$store.getters.userInfo.compId;

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopactive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        shopdel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 平台超管看所有，其他人只能看自己商户店铺
      if (this.roleId != 1) {
        this.basicListconfig.searchParameters.compId = this.compId;
      }
      this.basicListconfig.searchParameters.is_showAll = 1;
      getshoplist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    obtainDataSource() {
      areaGetlist().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "area_number") {
              item.options = this.renameSublistToChildren(res.data);
              console.log(
                "%c [ item.options ]-283",
                "font-size:13px; background:pink; color:#bf2c9f;",
                item.options
              );
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
      companyGetlist({ limit: 100000 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "comp_id") {
              item.options = res.data.map((list) => {
                return {
                  label: list.name,
                  value: list.id,
                };
              });
            }
            return item;
          });
        }
      });
    },
    renameSublistToChildren(tree) {
      if (Array.isArray(tree)) {
        tree.forEach((item) => {
          item.label = item.name;
          item.id = item.area_number;
          if (item.children && Array.isArray(item.children)) {
            item.children = this.renameSublistToChildren(item.children);
            // delete item.sub_list;
          } else if (item.children && !Array.isArray(item.children)) {
            throw new Error("sublist 属性不是一个数组");
          } else {
            this.renameSublistToChildren(item);
          }
        });
      } else if (typeof tree === "object" && tree !== null) {
        for (let key in tree) {
          this.renameSublistToChildren(tree[key]);
        }
      }
      // 返回处理后的树
      return tree;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/index.vue